"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.chat-thread-sharing.disabled': 'La funzione condivisione thread chat non è disponibile nel tuo piano attuale.',
};
